import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { FETCH_OFFERS } from '../../redux/Offers';
import Table from '../Table/Table.jsx';
import { tablesHeaders } from '../../consts/tablesConf';
import { handleShowOffer } from '../../helpers/utils';
import { BROWSE } from '../../consts/navigation';
import { vehicleTypes } from '../../consts/vehicleTypes';
import SingleRow from './SingleRow';

const OffersContainer = (props) => {
  const { offers, fetchOffers, vehicleType, history, match, isMobile, } = props;

  const handleOfferDetails = useCallback((id, whichFolder) => {
    const isTextNotSelected = window.getSelection().toString() === '';
    if (isTextNotSelected) {
      handleShowOffer(id, history, match, whichFolder);
    }
  }, [history, match])

  return (
    <Table
      whichFolder={BROWSE}
      tableHeaders={tablesHeaders[vehicleType][BROWSE]}
      fetchOffers={fetchOffers}
      totalCount={get(offers, 'total_count')}
      totalPages={get(offers, 'total_pages')}
      isLoading={get(offers, 'isLoading')}
      renderRow={SingleRow(isMobile, vehicleType)}
      onRowClick={handleOfferDetails}
      items={get(offers, 'offers')}
    />
  )
}


const mapStateToProps = (state) => {
  return {
    offers: get(state, ['offers']),
    isMobile: get(state, ['layout', 'isMobile']),
    vehicleType: state.vehicleType.vehicleType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchOffers: () => dispatch(FETCH_OFFERS()),
  };
};

OffersContainer.propTypes = {
  match: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  vehicleType: PropTypes.oneOf(Object.keys(vehicleTypes)).isRequired,
  history: PropTypes.object.isRequired,
  fetchOffers: PropTypes.func.isRequired,
  offers: PropTypes.shape({
    current_folder: PropTypes.string,
    new_offers_count: PropTypes.number,
    offers: PropTypes.array,
    total_count: PropTypes.number,
    total_pages: PropTypes.number,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(OffersContainer);
